import PropTypes from "prop-types";
import styles from "./SelectCompany.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import store from "../../Store/Store";
import { observer } from "mobx-react";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";

const SwitchCompany = observer(
  ({ onclose, isVisible, onclosepopup, className = "" }) => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // Store filtered companies
    const [selectedCompany, setSelectedCompany] = useState("");
    const [selectedCompany_id, setSelectedCompany_id] = useState("");
    const [selectedKYCCompany_id, setSelectedKYCCompany_id] = useState("");
    const [companyFetched, setCompanyFetched] = useState(false);
    const [searchTerm, setSearchTerm] = useState(""); // State for search input
    const [userFlow, setUserFlow] = useState("");

    useEffect(() => {
      setSelectedCompany(store.companyName);
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);

      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_companies`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: {},
      };

      axios
        .request(payload)
        .then((res) => {
          setData(res.data.data);
          setCompanyFetched(true);
          setFilteredData(res.data.data);
        })
        .catch((err) => console.log(err));
    }, []);

    const handleSearch = (event) => {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);

      // Filter data based on search input
      setFilteredData(
        data.filter((company) => company.brand.toLowerCase().includes(query)),
      );
    };

    const handelProceed = () => {
      store.setTradeName("")
      store.setCompanyName(selectedCompany);
      store.setCompId(selectedCompany_id);
      store.setUserType(userFlow);
      store.setKycCompanyId(selectedKYCCompany_id)
      store.refresh ? store.setRefresh(false) : store.setRefresh(true);
      onclose();
    };
    
    const getNewTokens = async (authData) => {
      if (!authData?.RefreshToken) {
        localStorage.removeItem("authToken");
        // navigate("/login");
        return;
      }

      try {
        const client = new CognitoIdentityProviderClient({
          region: "ap-south-1",
        });

        const params = {
          ClientId: config.Client_Id,
          AuthFlow: "REFRESH_TOKEN_AUTH",
          AuthParameters: {
            REFRESH_TOKEN: authData?.RefreshToken,
          },
        };

        const command = new InitiateAuthCommand(params);
        const refreshResponse = await client.send(command);

        if (refreshResponse.AuthenticationResult) {
          const newAuthToken = {
            AccessToken: refreshResponse.AuthenticationResult.AccessToken,
            RefreshToken: authData?.RefreshToken, // Keep old refresh token
            IdToken: refreshResponse.AuthenticationResult.IdToken,
          };

          localStorage.setItem("authToken", JSON.stringify(newAuthToken));
          setAuth(newAuthToken); // Update state
          if (store.refresh) {
            store.setRefresh(false);
          } else {
            store.setRefresh(true);
          }
        } else {
          localStorage.removeItem("authToken");
          // navigate("/login");
        }
      } catch (error) {
        console.log("Error refreshing tokens:", error);
        localStorage.removeItem("authToken");
        // navigate("/login");
      }
    };

    const isTokenExpired = (token) => {
      try {
        const decoded = jwtDecode(token);

        if (decoded && decoded.exp) {
          const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
          return decoded.exp < currentTime;
        }
      } catch (error) {
        console.log("Error decoding token:", error);
        return true; // Treat decoding failures as expired tokens
      }
      return true;
    };
    if (!isVisible) return null;

    return (
      <button
        className={[styles.selectCompany, className].join(" ")}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={styles.selectCompanyInner}>
          <div className={styles.selectCompanyParent}>
            <div className={styles.selectCompany1}>Select Brand</div>
            <button
              className={styles.xCircle}
              onClick={() => {
                onclose();
                onclosepopup();
              }}
            >
              <img className={styles.icon} alt="" src="/icon1.svg" />
            </button>
          </div>
        </div>

        {/* Search Bar */}
        <div className={styles.textFieldParent}>
          <div className={styles.textField}>
            <div className={styles.content}>
              <img
                className={styles.leadingIcon}
                alt=""
                src="/leadingicon4.svg"
              />
              <input
                className={styles.labelText}
                placeholder="Search Brand"
                type="text"
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
          </div>

          {/* Filtered Company List */}
          <div className={styles.companyListContainer}>
            {filteredData.length > 0 ? (
              filteredData.map((details, index) => (
                <button
                  key={index}
                  className={styles.groupParent}
                  onClick={() => {
                    setSelectedCompany(details.brand);
                    setSelectedCompany_id(details.ledger_label);
                    setUserFlow(details.company_flow);
                    setSelectedKYCCompany_id(details.kyc_company_id)
                  }}
                >
                  {selectedCompany === details.brand ? (
                    <img
                      className={styles.frameChild}
                      alt=""
                      src="/group-2442.svg"
                    />
                  ) : (
                    <div className={styles.frameItem} />
                  )}
                  <div className={styles.sunshineinfotech}>{details.brand}</div>
                </button>
              ))
            ) : (
              <>
                {companyFetched && (
                  <div className={styles.noResults}>No brands found</div>
                )}
              </>
            )}
          </div>
          {/* Proceed Button */}
          <button className={styles.loadsButtons} onClick={handelProceed}>
            <img
              className={styles.boxArrowInDownIcon}
              alt=""
              src="/boxarrowindown11.svg"
            />
            <b className={styles.loads}>{`Proceed `}</b>
          </button>
        </div>
      </button>
    );
  },
);

SwitchCompany.propTypes = {
  className: PropTypes.string,
};

export default SwitchCompany;
